var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sitelinks),function(sitelink,index){return _c('div',{key:index,staticClass:"container",attrs:{"index":index}},[_c('nuxt-link',{attrs:{"to":{ path: '/' + sitelink}}},[_vm._v(_vm._s(sitelink))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }